import type { AgentSelectorItem, TeamSelectorItem } from "@marker/ui";

import type { components } from "../api/schema";

type Agent = components["schemas"]["AgentResponse"];
type Team = components["schemas"]["TeamResponse"];

interface Page<T> {
  items: T[];
}

function mapAgents(pages?: readonly Page<Agent>[]): AgentSelectorItem[] {
  return (pages?.flatMap((page) => page.items) ?? []).map((item) => ({
    createdAt: item.created_at,
    id: item.id,
    label: item.display_name,
    teamId: item.team_id,
  }));
}

export function buildSelectorItems(
  agentPages: readonly Page<Agent>[] | undefined,
  teams: readonly Team[],
) {
  return {
    agentSelectorItems: mapAgents(agentPages),
    teamSelectorItems: teams.map(
      (team): TeamSelectorItem => ({
        id: team.id,
        label: team.display_name,
      }),
    ),
  };
}
